module.exports = __webpack_public_path__ + "static/media/04.c13a44c2.png";